/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Martial_Arts_TermsInputs */

const en_service_type_martial_arts_terms = /** @type {(inputs: Service_Type_Martial_Arts_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mma, bjj, jiu jitsu, muay thai, karate, judo, krav maga, self defence`)
};

const pl_service_type_martial_arts_terms = /** @type {(inputs: Service_Type_Martial_Arts_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mma, bjj, jiu jitsu, muay thai, karate, judo, krav maga, samoobrona`)
};

/**
* | output |
* | --- |
* | "mma, bjj, jiu jitsu, muay thai, karate, judo, krav maga, self defence" |
*
* @param {Service_Type_Martial_Arts_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_martial_arts_terms = /** @type {((inputs?: Service_Type_Martial_Arts_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Martial_Arts_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_martial_arts_terms(inputs)
	return en_service_type_martial_arts_terms(inputs)
});